import { gql, useQuery } from "@apollo/client";
import { AppContext } from "@edx/frontend-platform/react";
import { useContext } from "react";

const BASIC_COURSE_DETAILS = gql`
  fragment BasicCourseDetails on Courses {
    id
    price
    openedxCourseId
    courseTags {
      tag
    }
    inviteOnly
    published
  }
`;

const OPENEDX_COURSE_DETAILS = gql`
  fragment OpenedxCourseDetails on CourseOverviewsCourseoverview {
    id
    displayName
    displayNumberWithDefault
    courseImageUrl
    effort
    shortDescription
    start
  }
`;

const GET_DISCOVER_COURSES = gql`
  query GetDiscoverCourses($userId: Int4!) {
    discoverCourses: courses(where: {published: {_eq: "true"}, _not: {courseEnrollments: {userId: {_eq: $userId}}}}) {
      ...BasicCourseDetails
      details: _CourseOverviewsCourseoverview {
        ...OpenedxCourseDetails
      }
    }
  }
  ${BASIC_COURSE_DETAILS}
  ${OPENEDX_COURSE_DETAILS}
`;

const GET_ENROLLED_COURSES = gql`
  query GetEnrolledCourses {
    enrolledCourses: courseEnrollments {
      course {
        ...BasicCourseDetails
        details: _CourseOverviewsCourseoverview {
          ...OpenedxCourseDetails
        }
      }
    }
  }
  ${BASIC_COURSE_DETAILS}
  ${OPENEDX_COURSE_DETAILS}
`;

const GET_COURSE_BY_ID = gql`
  query GetCourseById($courseId: Text) {
    courseById: courses(where: {openedxCourseId: {_eq: $courseId}}) {
      ...BasicCourseDetails
      details: _CourseOverviewsCourseoverview {
        ...OpenedxCourseDetails
      }
    }
  }
  ${BASIC_COURSE_DETAILS}
  ${OPENEDX_COURSE_DETAILS}
`;

export const useDiscoverCourses = () => {
  const { authenticatedUser } = useContext(AppContext);

  const { data, loading, error } = useQuery(GET_DISCOVER_COURSES, {
    variables: {
      userId: authenticatedUser.id
    },
    context: { headers: { "x-hasura-role": "learner" } },
    skip: !authenticatedUser.id
  });

  return {
    discoverCourses: data?.discoverCourses || [],
    loading,
    error
  };
};

export const useEnrolledCourses = () => {
  const { data, loading, error } = useQuery(GET_ENROLLED_COURSES, {
    context: { headers: { "x-hasura-role": "learner" } },
  });

  return {
    enrolledCourses: data?.enrolledCourses || [],
    loading,
    error
  };
};

export const useCourseById = (courseId) => {
  const { data, loading, error } = useQuery(GET_COURSE_BY_ID, {
    variables: { courseId },
    context: { headers: { "x-hasura-role": "learner" } },
    skip: !courseId
  });

  return {
    course: data?.courseById?.[0] || {},
    loading,
    error
  };
};
